import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { getMimeType } from "../../utils/helper";
import MyTiffViewer from "../Popups/TifViewer";

const ImagePreview = ({ file }) => {
  const base64 = file.src.startsWith("data:")
    ? file.src.split(",")[1]
    : file.src;

  const mimeType = getMimeType(base64);

  if (mimeType.startsWith("image/")) {
    if (mimeType === "image/tiff") {
      return (
        <div className="file-item d-flex flex-column align-items-center file-preview">
          <div className="file-preview-image">
            <MyTiffViewer data={base64} />
          </div>

          <p className="file-preview-name">
            {file.fileName}
          </p>
        </div>
      );
    }

    return (
      <div className="file-item">
        <img
          alt={file.fileName}
          src={`data:${mimeType};base64,${base64}`}
          className="d-block"
        />
        <p>{file.fileName}</p>
      </div>
    );
  }

  return (
    <div className="file-item">
      <FontAwesomeIcon
        icon={faFilePdf}
        size="1x"
        color="red"
      />
      <p>{file.fileName}</p>
    </div>
  );
};

export default ImagePreview;